'use client';

import { c as _c } from "react/compiler-runtime";
import { type PublicUser } from '@shared/all/domains/user';
import { AlertTriangle, ShieldOff, VolumeX } from 'lucide-react';
type Props = {
  userData: PublicUser;
  username: string;
};
const BlockedProfileBanner = t0 => {
  const $ = _c(18);
  const {
    userData,
    username
  } = t0;
  if (userData.blockedByUser) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ShieldOff className="h-10 w-10 text-textSecondary/50" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== username) {
      t2 = <h2 className="text-lg font-semibold">@{username} has blocked you</h2>;
      $[1] = username;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p className="text-sm text-textSecondary/70">You cannot view their posts or interact with their content.</p>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t2) {
      t4 = <div className="mx-auto my-4 flex max-w-lg flex-col items-center gap-3 rounded-lg border border-ds-border-standard bg-background-secondary p-8 text-center">{t1}{t2}{t3}</div>;
      $[4] = t2;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  if (userData.blocked) {
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <AlertTriangle className="h-10 w-10 text-textSecondary/50" />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    let t2;
    if ($[7] !== username) {
      t2 = <h2 className="text-lg font-semibold">You blocked @{username}</h2>;
      $[7] = username;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p className="text-sm text-textSecondary/70">You cannot view their posts or interact with their content. Unblock them from the profile menu to restore access.</p>;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t2) {
      t4 = <div className="mx-auto my-4 flex max-w-lg flex-col items-center gap-3 rounded-lg border border-ds-border-standard bg-background-secondary p-8 text-center">{t1}{t2}{t3}</div>;
      $[10] = t2;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  if (userData.muted) {
    let t1;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <VolumeX className="h-10 w-10 text-textSecondary/50" />;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    let t2;
    if ($[13] !== username) {
      t2 = <h2 className="text-lg font-semibold">You muted @{username}</h2>;
      $[13] = username;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    let t3;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p className="text-sm text-textSecondary/70">Posts from this user are hidden from your feed. Unmute them from the profile menu to see their content again.</p>;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    let t4;
    if ($[16] !== t2) {
      t4 = <div className="mx-auto my-4 flex max-w-lg flex-col items-center gap-3 rounded-lg border border-ds-border-standard bg-background-secondary p-8 text-center">{t1}{t2}{t3}</div>;
      $[16] = t2;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  return null;
};
export default BlockedProfileBanner;